<template>
  <el-row :gutter="16">
    <el-col :span="24">
      <PSelect
        v-model="empresaFake"
        disabled
        placeholder="Selecione uma empresa"
        label="Empresa"
        :options="[
          {
            label: 'Todas',
            value: '1'
          }
        ]"
        filterable
        clearable
      />
    </el-col>
  </el-row>
</template>

<script setup lang="ts">
import { PSelect } from "@f360-dev/f360-prisma";
import {
  formNFeIntegracaoSchema,
  IFormularioNFeIntegracaoSchema
} from "./formularioNfeSchema";
import { useForm } from "vee-validate";
import { onMounted, ref } from "vue";
import { TWebservice } from "../../../../services/PainelDeIntegracaoesGateway";
import { DITypes } from "@/core/@types/types";
import { IFinancasFeatureGateway } from "@/features/financas/services/ports/FinancasFeatureGateway";
import { diContainer } from "@/inversify.config";

const props = defineProps<{
  webservice?: TWebservice;
}>();

const empresaFake = ref("1");

const financasFeatureGateway = diContainer.get<IFinancasFeatureGateway>(
  DITypes.FINANCAS_FEATURES
);

const { handleSubmit, errors, values, setValues } =
  useForm<IFormularioNFeIntegracaoSchema>({
    validationSchema: formNFeIntegracaoSchema,
    initialValues: {
      empresaId: props.webservice?.empresa ?? "",
      origemSimplificada: "1"
    }
  });

const obterEmpresaPorConfiguracao = async () => {
  if (!financasFeatureGateway) return;

  const response = await financasFeatureGateway.obterEmpresaPorConfiguracao(
    props.webservice?.id ?? ""
  );

  if (response?.Ok) {
    setValues({
      empresaId: response.Result,
      origemSimplificada: "1"
    });
  }
};

onMounted(async () => {
  try {
    await obterEmpresaPorConfiguracao();
  } catch (error) {
    console.error(error);
  }
});

defineExpose({
  handleSubmit,
  errors,
  values
});
</script>

<style scoped></style>
